
import { escape } from "lodash";
import { TextIcon } from "lucide-react";

import { prop, define, useCraftProp } from "@/components/builder/utils";

import ContentEditable from "../utils/ContentEditable";

import BasePreview from "./base";

function TextPreview({ ...props }) {
  const { value, setValue } = useCraftProp('content')

  return <BasePreview {...props}>
    <ContentEditable
      html={value}
      onChange={setValue}
      tagName='p'
    />
  </BasePreview>
}

export default define('text', TextPreview, 'p')
  .tag({ children: 'content' })
  .palete(<TextIcon size={16} />, 'Text', 'Content')
  .property(prop.new('Content', 'content').hide().own())
  .property(prop.predefined.customClass())
  .property(prop.predefined.textContent())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(prop.predefined.textColor())
  .property(prop.predefined.align())
  .property(prop.predefined.textAlignContainer())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.fontSize())
  .property(prop.predefined.fontWeight())
  .property(prop.predefined.fontFamily())
  .property(prop.predefined.fontDecoration())
  .property(prop.predefined.textShadow())
  .property(prop.predefined.attributes())
  .defaultProps({
    content: escape('Text here...'),
    fontSize: '14px',
    textColor: 'gray-900',
    outline: {
      outline: 'none',
    },
  })
  .build()
